import Vue from 'vue'
import _ from 'lodash'
import authorizationService from '@/core/auth/authorization-service'
import constants from '@/core/constants'

const getDefaultState = () => {
  return {
    current: {
      errand: null
    },
    errands: {},
    events: {},
    tasks: {},
    attachments: {},
    createdErrand: {},
    members: null
  }
}

const state = getDefaultState()

const actions = {
  resetEntityState({ commit }) {
    commit('reset_state')
  },
  setActiveEntity({ commit }, payload) {
    commit('set_active_entity', payload)
  },
  tryAddEntities({ dispatch }, payload) {
    if (payload.flattenByKey) {
      _.forEach(payload.data, entity => {
        dispatch('tryAddEntity', { type: payload.type, key: entity[payload.key], data: entity })
      })
    } else {
      dispatch('tryAddEntity', { type: payload.type, key: payload.key, data: payload.data })
    }
  },
  tryAddEntity({ commit }, payload) {
    commit('try_add_entity', payload)
  },
  addOrUpdateEntity({ commit }, payload) {
    commit('add_or_update_entity', payload)
  },
  deleteEntity({ commit }, payload) {
    commit('delete_entity', payload)
  },
  setMembers({ commit }, payload) {
    commit('set_members', payload)
  }
}

const mutations = {
  reset_state(state) {
    _.assign(state, getDefaultState())
  },
  delete_entity(state, payload) {
    Vue.delete(state[payload.type], payload.key)
  },
  set_active_entity(state, payload) {
    state.current[payload.key] = payload.entity
  },
  try_add_entity(state, payload) {
    if(!state[payload.type][payload.key]) {
      Vue.set(state[payload.type], payload.key, payload.data)
    }
  },
  add_or_update_entity(state, payload) {
    if(!state[payload.type][payload.key]) {
      Vue.set(state[payload.type], payload.key, payload.data)
    } else {
      state[payload.type][payload.key] = payload.data
    }
  },
  set_members(state, payload) {
    state.members = payload
  }
}

const getters = {
  currentErrand: state => state.current.errand,
  currentUserCompany: (state, getters) => {
    const company = getters.companies[authorizationService.getClaim(constants.customClaims.companyKey)]
    if(!company) {
      // fallback for v2 company keys
      return _.find(getters.companies, company => company.channel === authorizationService.getClaim(constants.customClaims.channel) && company.accessGroup === authorizationService.getClaim(constants.customClaims.accessGroup))
    }
    return company
  },
  errands: state => state.errands,
  tasks: state => state.tasks,
  attachments: state => state.attachments,
  events: state => state.events,
  polygonEmployee: state => state.polygonEmployee,
  createdErrand: state => state.createdErrand,
  members: state => state.members
}

export default {
  state,
  actions,
  mutations,
  getters
}
